module.exports = __webpack_public_path__ + "img/hgallery.c48c9592.png";